export const Skeleton = ({ h = 16, w = "100%", r = 2, style, className = "" }) => (
  <span className={`sk ${className}`} style={{ height: h, width: w, borderRadius: r, ...style }} aria-hidden="true" />
);

export const SkeletonText = ({ lines = 3, last = "70%", gap = 10, h = 14 }) => (
  <span className="sk-stack" style={{ gap }} aria-hidden="true" data-testid="skeleton-text">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} h={h} w={i === lines - 1 ? last : "100%"} />
    ))}
  </span>
);

export const SkeletonRows = ({ rows = 6, h = 44, gap = 8, testid = "skeleton-rows" }) => (
  <span className="sk-stack" style={{ gap }} aria-hidden="true" data-testid={testid}>
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} h={h} />
    ))}
  </span>
);

export const SkeletonGrid = ({ cells = 6, testid = "skeleton-grid" }) => (
  <div className="photo-grid" aria-hidden="true" data-testid={testid}>
    {Array.from({ length: cells }).map((_, i) => (
      <div key={i} className={`photo-cell sk${i % 5 === 2 ? " tall" : ""}`} />
    ))}
  </div>
);
